import { jsxs as C, jsx as e } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as l } from "./index.es2359.js";
function t({ size: i = l }) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: i,
      height: i,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("rect", { shapeRendering: "optimizeQuality", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M32 23.5C32 28.1944 28.1944 32 23.5 32C18.8056 32 15 28.1944 15 23.5C15 18.8056 18.8056 15 23.5 15C28.1944 15 32 18.8056 32 23.5Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M36.6666 23.6666C36.2677 23.6666 35.9443 23.99 35.9443 24.3888V40.2777C35.9443 40.6766 36.2677 41 36.6666 41H40.2777C40.6765 41 40.9999 40.6766 40.9999 40.2777V24.3888C40.9999 23.99 40.6765 23.6666 40.2777 23.6666H36.6666Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M29.4443 31.6111C29.4443 31.2123 29.7677 30.8889 30.1665 30.8889L33.7777 30.8888C34.1765 30.8888 34.4999 31.2122 34.4999 31.6111V40.2777C34.4999 40.6766 34.1765 41 33.7777 41H30.1666C29.7677 41 29.4443 40.6766 29.4443 40.2777V31.6111Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M23.6666 35.2222C23.2677 35.2222 22.9443 35.5455 22.9443 35.9444V40.2777C22.9443 40.6766 23.2677 41 23.6666 41H27.2777C27.6765 41 27.9999 40.6766 27.9999 40.2777V35.9444C27.9999 35.5455 27.6765 35.2222 27.2777 35.2222H23.6666Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M22.7909 25.1502V24.8188C22.7909 24.5592 22.8207 24.333 22.8804 24.1401C22.94 23.9472 23.04 23.7665 23.1803 23.5982C23.3206 23.4263 23.51 23.2474 23.7485 23.0615C23.994 22.8686 24.1887 22.702 24.3325 22.5617C24.4798 22.4214 24.585 22.2811 24.6481 22.1408C24.7148 21.997 24.7481 21.8304 24.7481 21.641C24.7481 21.3429 24.6464 21.1166 24.443 20.9623C24.243 20.8045 23.9607 20.7255 23.5959 20.7255C23.2732 20.7255 22.9698 20.7711 22.6857 20.8623C22.4016 20.9535 22.121 21.0675 21.8439 21.2043L21.4072 20.2783C21.7264 20.103 22.0719 19.9627 22.4437 19.8574C22.819 19.7487 23.2311 19.6943 23.6801 19.6943C24.3956 19.6943 24.948 19.868 25.3374 20.2152C25.7302 20.5624 25.9266 21.0202 25.9266 21.5884C25.9266 21.9005 25.8775 22.1689 25.7793 22.3933C25.6811 22.6143 25.5355 22.8195 25.3426 23.0089C25.1532 23.1948 24.9235 23.3912 24.6534 23.5982C24.4324 23.7735 24.2623 23.9261 24.1431 24.0559C24.0273 24.1822 23.9466 24.3102 23.901 24.44C23.859 24.5697 23.8379 24.7258 23.8379 24.9082V25.1502H22.7909Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M22.591 26.8443C22.591 26.5567 22.6647 26.355 22.812 26.2393C22.9628 26.12 23.1469 26.0604 23.3644 26.0604C23.5749 26.0604 23.7555 26.12 23.9063 26.2393C24.0571 26.355 24.1325 26.5567 24.1325 26.8443C24.1325 27.1249 24.0571 27.3284 23.9063 27.4546C23.7555 27.5774 23.5749 27.6388 23.3644 27.6388C23.1469 27.6388 22.9628 27.5774 22.812 27.4546C22.6647 27.3284 22.591 27.1249 22.591 26.8443Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.5 32C28.1944 32 32 28.1944 32 23.5C32 18.8056 28.1944 15 23.5 15C18.8056 15 15 18.8056 15 23.5C15 28.1944 18.8056 32 23.5 32ZM23.5 31C27.6421 31 31 27.6421 31 23.5C31 19.3579 27.6421 16 23.5 16C19.3579 16 16 19.3579 16 23.5C16 27.6421 19.3579 31 23.5 31Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36.6666 23.6666C36.2677 23.6666 35.9443 23.99 35.9443 24.3888V40.2777C35.9443 40.6766 36.2677 41 36.6666 41H40.2777C40.6765 41 40.9999 40.6766 40.9999 40.2777V24.3888C40.9999 23.99 40.6765 23.6666 40.2777 23.6666H36.6666ZM37.0277 39.9166H39.9166V24.75H37.0277V39.9166Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.1665 30.8889C29.7677 30.8889 29.4443 31.2123 29.4443 31.6111V40.2777C29.4443 40.6766 29.7677 41 30.1666 41H33.7777C34.1765 41 34.4999 40.6766 34.4999 40.2777V31.6111C34.4999 31.2122 34.1765 30.8888 33.7777 30.8888L30.1665 30.8889ZM30.5277 31.9722V39.9166H33.4166V31.9722L30.5277 31.9722Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.9443 35.9444C22.9443 35.5455 23.2677 35.2222 23.6666 35.2222H27.2777C27.6765 35.2222 27.9999 35.5455 27.9999 35.9444V40.2777C27.9999 40.6766 27.6765 41 27.2777 41H23.6666C23.2677 41 22.9443 40.6766 22.9443 40.2777V35.9444ZM24.0277 39.9166V36.3055H26.9166V39.9166H24.0277Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricBaseForecastIcon
};
//# sourceMappingURL=index.es382.js.map
